/*es5-ext/array/from/index*/
function _(require, module, exports) {
    module.exports = require(272    /* ./is-implemented */)() ? Array.from : require(273    /* ./shim */);
}